import { useSignalRHubStore } from '../stores/useSignalR';
import { useQuery } from '@tanstack/react-query';
import { HubConnectionState } from '@microsoft/signalr';

export function useSignalRQuery({
  hubName,
  method,
  args = [],
  queryKey,
  options = {},
}: {
  hubName: string;
  method: string;
  args?: any[];
  queryKey: string | any[];
  options?: any;
}) {
  const signalr = useSignalRHubStore((state) => state.hubs[hubName]);

  const invokeMethod = async () => {
    if (signalr?.connection?.state !== HubConnectionState.Connected) {
      throw new Error('SignalR is not connected');
    }

    return await signalr?.connection?.invoke(method, ...args);
  };

  // Use useQuery from react-query to manage the loading, error, and success states
  return useQuery({
    queryKey,
    queryFn: invokeMethod,
    enabled:
      signalr?.connection?.state === HubConnectionState.Connected ||
      signalr?.state === HubConnectionState.Disconnected,
    ...options,
  });
}
